import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { URLdecode, URLencode } from "../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import {
  errorDescription,
  errorTitle,
} from "../../controllers/errorController";
import { configurations } from "../../configurations";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: window.innerWidth > 600 ? 600 : "90vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
};

export default function GlobalErrorModal() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = URLdecode();

  const handleClose = () => {
    const parameters = { ...params };
    delete parameters?.error;
    delete parameters?.errorCode;
    delete parameters?.errorPayload;
    delete parameters?.errorType;
    navigate(`${location.pathname}?${URLencode(parameters)}`);
  };

  const handleRetry = () => {
    const parameters = { ...params };
    delete parameters?.error;
    delete parameters?.errorCode;
    delete parameters?.errorPayload;
    delete parameters?.errorType;
    navigate(`${location.pathname}?${URLencode(parameters)}`);
    window.location.reload();
  };

  const handleOption = (action) => {
    const parameters = { ...params, action };
    delete parameters?.error;
    delete parameters?.errorCode;
    delete parameters?.errorPayload;
    delete parameters?.errorType;
    navigate(`${location.pathname}?${URLencode(parameters)}`);
  };

  const buttons = [
    {
      type: "secondary",
      label: "Cancel",
      action: () => handleClose(),
      visible: true,
    },
    {
      type: "primary",
      label: "Choose another method",
      action: () => handleClose(),
      visible: ["82"]?.includes(params?.errorCode),
    },
    {
      type: "primary",
      label: "Different Accommodation",
      action: () => handleOption(configurations.errorActions.differentHotel),
      visible: [
        configurations.errorCodes.accommodationNoAvailability,
      ]?.includes(params?.errorCode),
    },
    {
      type: "primary",
      label: "Different Dates",
      action: () => handleClose(),
      visible: [
        configurations.errorCodes.accommodationNoAvailability,
      ]?.includes(params?.errorCode),
    },
    {
      type: "primary",
      label: "Retry",
      action: () => handleRetry(),
      visible: ![
        "82",
        "10",
        configurations.errorCodes.accommodationNoAvailability,
      ]?.includes(params?.errorCode),
    },
  ];

  const formatTextWithBold = (text) => {
    if (!text) return null;

    const parts = text.split(/(\*\*.*?\*\*)/g);

    return parts.map((part, index) =>
      part.startsWith("**") && part.endsWith("**") ? (
        <strong key={index} className="text-sm">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      )
    );
  };

  return (
    <div>
      <Modal
        open={params?.error}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex flex-col font-main w-full">
            <div className="py-4 w-full flex items-center justify-between px-4 border-b border-gray-300">
              <span className="font-bold text-xl">
                {errorTitle(params?.errorType)}
              </span>
              <button onClick={handleClose}>
                <img
                  src="/IconClose4.svg"
                  alt=""
                  className="w-6 object-contain"
                />
              </button>
            </div>
            <div className="w-full py-2 px-4">
              <span className="text-sm text-primaryText">
                {formatTextWithBold(
                  errorDescription(
                    params?.errorCode,
                    params?.errorPayload ? JSON.parse(params?.errorPayload) : {}
                  )
                )}
              </span>
            </div>
            <div className="py-4 w-full flex flex-wrap items-center justify-end px-4 gap-2">
              {buttons
                ?.filter((btn) => btn?.visible)
                ?.map((btn, index) => (
                  <button
                    key={index}
                    className={
                      btn?.type === "secondary"
                        ? "text-sm h-8 px-5 rounded-md border border-gray-300 text-black"
                        : "text-sm h-8 px-5 rounded-md bg-primary1 text-white"
                    }
                    onClick={btn?.action}
                  >
                    {btn?.label}
                  </button>
                ))}
              {/* <button
                className="text-sm h-8 px-5 rounded-md bg-primary1 text-white"
                onClick={handleRetry}
              >
                Choose another payment method
              </button>
              <button
                className="text-sm h-8 px-5 rounded-md bg-primary1 text-white"
                onClick={handleRetry}
              >
                Retry
              </button> */}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
